import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              {siteInfo.description}。从流量小生到顶级流量，明星黑料一网打尽，带你看清光鲜背后的真实一面。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  用户协议
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#weibo" className="text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#wechat" className="text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#rss" className="text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}